import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { SharedService } from '../../@core/services/shared.service'
import { NbDialogRef } from '@nebular/theme'
import { format, parseISO } from 'date-fns'
import { PvsAvatarFrameStyle } from '../full-size-avatar/full-size-avatar.component'

export enum FieldType {
    STRING,
    PASSWORD,
    TEXT_AREA,
    NUMBER,
    COMBOBOX,
    GENDER,
    DATE,
    DATE_TIME,
    DATE_TIME_VIEW,
    FILE,
    FILE_AVATAR,
    FILE_ALL_IMAGES,
    CHECKBOX,
    TEACHER,
    All_USERS,
    JSON,
    PHONE_NUMBER,
}
export enum ButtonType {
    NO_BUTTON,
    OK_ONLY,
    OK_CANCEL,
    YES_NO,
    YES_NO_10_SECONDS,
}

export enum PvsFieldValidation {
    REQUIRED,
    PHONE_NUMBER,
    VERIFY_CODE,
    EMAIL,
}
export interface PvsFormFieldFormat {
    textAreaRows?: number
    capitalizeFirstCharacter?: boolean
    avatarFrameStyle?: PvsAvatarFrameStyle
    avatarRatio?: number
    avatarResizeToWidth?: number
}
export interface PvsFormField {
    name: string
    title?: string
    type?: FieldType
    data?: any
    rules?: Array<PvsFieldValidation>
    disabled?: boolean
    format?: PvsFormFieldFormat
}
export interface PvsFormSetting {
    /**
     * Dialog title
     */
    title?: string
    headerIcon?: string
    /**
     * The text that be displayed on dialog body
     */
    content?: string
    contentHtml?: string
    fields?: Array<PvsFormField>
    data?: object
    focusToFirstItem?: boolean
    buttonType?: ButtonType
    cssWidth?: string
    /**
     * The function that be executed when user click the OK button
     */
    okFunction?: Function
}
export interface PvsFormResponse {
    /**
     *  Data updated by user
     */
    editedData: any
    /**
     *  Data response of okFunction
     */
    okFunctionResponse?: any
}
@Component({
    templateUrl: './pvs-form-dialog.component.html',
    styleUrls: ['./pvs-form-dialog.component.css'],
    selector: 'app-form-dialog',
})
export class PvsFormDialogComponent implements OnInit, OnChanges, AfterViewInit {
    FieldType = FieldType
    ButtonType = ButtonType
    PvsAvatarFrameStyle = PvsAvatarFrameStyle

    @Input() settings: PvsFormSetting

    displayData: any // use to store data that showing on dialog
    errors: any // use to store all errors of data that showing on dialog
    hasError: boolean = false
    genderType: Array<any>
    dateType: Array<any>
    dateTimeType: Array<any>
    jsonType: Array<any>
    buttonType: ButtonType
    countDownSeconds: number = 6
    countDownInterval

    constructor(protected dialogRef: NbDialogRef<any>, public sharedService: SharedService) {}

    ngOnInit() {
        this.ngOnChanges(null)
    }
    ngOnChanges(changes: SimpleChanges): void {
        console.log(this.settings)
        this.settings = this.settings || {}
        this.displayData = { ...this.settings.data } // clone input data
        // set default value
        this.errors = {}
        this.buttonType =
            typeof this.settings?.buttonType === 'undefined' ? ButtonType.OK_CANCEL : this.settings.buttonType
        console.log('buttonType', this.buttonType)
        this.settings.fields = this.settings.fields || []
        // processing gender
        this.genderType = this.settings.fields.filter((e) => e.type === FieldType.GENDER)
        this.genderType.forEach((e) => {
            const value = this.displayData?.[e.name]
            if (typeof value === 'undefined') {
                return
            }
            this.displayData[e.name] = value === 'true' || value === '1' || value === true ? '1' : '0'
        })
        // processing date type
        this.dateType = this.settings.fields.filter((e) => e.type === FieldType.DATE)
        this.dateType.forEach((e) => {
            const value = this.displayData?.[e.name]
            if (typeof value === 'undefined') {
                return
            }
            // convert to date
            if (value && typeof value === 'string') {
                this.displayData[e.name] = parseISO(value)
            }
        })
        // processing date time type
        this.dateTimeType = this.settings.fields.filter((e) => e.type === FieldType.DATE_TIME)
        this.dateTimeType.forEach((e) => {
            const value = this.displayData?.[e.name]
            if (typeof value === 'undefined') {
                return
            }
            // convert to date
            if (value && typeof value === 'string') {
                this.displayData[e.name] = parseISO(value)
            }
        })
        // processing JSON
        this.jsonType = this.settings.fields.filter((e) => e.type === FieldType.JSON)
        this.jsonType.forEach((e) => {
            const value = this.displayData?.[e.name]
            this.displayData[e.name] = JSON.stringify(value || null, null, 4)
        })
        // count down
        this.countDownInterval = setInterval(() => {
            this.countDownSeconds = this.countDownSeconds - 1
            if (this.countDownSeconds === 0) {
                clearInterval(this.countDownInterval)
            }
        }, 1000)
    }
    ngAfterViewInit() {
        if (this.settings.focusToFirstItem !== false) {
            this.focusToFirstItem()
        }
    }

    focusToFirstItem() {
        const rows = Array.from(document.querySelectorAll('.app-form-dialog-container .row-field'))
        if (!rows?.length) {
            return
        }
        for (const row of rows) {
            // input
            const input = row.getElementsByTagName('input')[0] as HTMLInputElement
            if (input && !input.disabled) {
                input.focus()
                return
            }
            // textarea
            const textarea = row.getElementsByTagName('textarea')[0] as HTMLTextAreaElement
            if (textarea && !textarea.disabled) {
                textarea.focus()
                return
            }
        }
    }

    validateField(field) {
        let value = this.displayData[field.name]
        if (value && typeof value === 'string') {
            value = value.trim()
        }
        // remove errors
        delete this.errors[field.name]

        const rules = field?.rules ?? []
        for (const validation of rules) {
            if (this.errors[field.name]) {
                continue
            }
            switch (validation) {
                case PvsFieldValidation.REQUIRED: {
                    if (!value) {
                        this.errors[field.name] = 'This field is required'
                    }
                    break
                }
                case PvsFieldValidation.PHONE_NUMBER: {
                    // if (value && !value.match(/^0?[1-9]\d{8}$/g)) {
                    if (value && !value.match(/^\d{10}$/g)) {
                        this.errors[field.name] = 'Incorrect phone number'
                    }
                    break
                }
                case PvsFieldValidation.VERIFY_CODE: {
                    if (value && !value.match(/^\d{6}$/g)) {
                        this.errors[field.name] = 'Incorrect format'
                    }
                    break
                }
                case PvsFieldValidation.EMAIL: {
                    if (value && !value.match(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/g)) {
                        this.errors[field.name] = 'Incorrect format'
                    }
                    break
                }
            }
        }
        // check json
        if (!this.errors[field.name] && value && field.type === FieldType.JSON) {
            try {
                JSON.parse(value)
            } catch {
                this.errors[field.name] = 'Incorrect format'
            }
        }
        // set hasError flag
        this.hasError = !!Object.keys(this.errors).length
    }

    getAvatarHdFieldName(avatarFieldName: string): string {
        return avatarFieldName.replace(/Url$/g, 'HdUrl')
    }

    async onOk() {
        // re-validate all fields
        if (!this.hasError) {
            this.settings.fields.forEach((f) => {
                this.validateField(f)
            })
        }
        if (this.hasError) {
            return
        }

        const temp = { ...this.displayData }
        this.genderType.forEach((e) => {
            const value = temp?.[e.name]
            if (typeof value !== 'undefined') {
                temp[e.name] = value === '1'
            }
        })
        this.dateType.forEach((e) => {
            const value = temp?.[e.name]
            if (typeof value === 'undefined' || value === null) {
                temp[e.name] = null
            } else {
                temp[e.name] = format(temp[e.name], 'yyyy-MM-dd') // important: prevent convert to timezone
            }
        })
        this.dateTimeType.forEach((e) => {
            const value = temp?.[e.name]
            if (typeof value !== 'undefined') {
                temp[e.name] = temp[e.name].toISOString()
            }
        })
        this.jsonType.forEach((e) => {
            const value = temp?.[e.name]?.trim()
            temp[e.name] = null
            if (!!value) {
                temp[e.name] = JSON.parse(value)
            }
        })
        if (this.settings.okFunction) {
            try {
                const okFunctionResponse = await this.settings.okFunction(temp)
                if (okFunctionResponse) {
                    this.dialogRef.close({
                        editedData: temp,
                        okFunctionResponse: okFunctionResponse,
                    })
                }
            } catch (e) {}
        } else {
            this.dialogRef.close({
                editedData: this.displayData,
                okFunctionResponse: null,
            })
        }
    }

    onCancel() {
        this.dialogRef.close(null)
    }

    onFieldValueChange(value, field) {
        // capitalize first character
        if ((field.type ?? FieldType.STRING) === FieldType.STRING && field.format?.capitalizeFirstCharacter && value) {
            this.displayData[field.name] = value
                .split(' ')
                .map((word) => (word[0]?.toUpperCase() ?? '') + (word.slice(1) ?? ''))
                .join(' ')
        }
        this.validateField(field)
    }

    onKeyPress($event, fieldName) {
        if ($event.key !== 'Enter') {
            return
        }

        // last field
        if (this.settings.fields[this.settings.fields.length - 1]?.name === fieldName) {
            return this.onOk()
        }
    }

    onFileSelected($event, field) {
        const file: File = $event.target.files[0]
        if (file) {
            this.displayData[field.name] = file
        }
        this.validateField(field)
    }
}
